module.exports = __webpack_public_path__ + "static/media/drapcode-logo-bluegreen.38e3fceb.svg";